import axios from 'axios'
import dispatchCustomEventGlobally from 'www/utils/withDependences/dispatchCustomEventGlobally'

/**
 * @description
 *
 * Для отправки данных POST запросом можно использовать serializeObject() из utils, чтобы привести их к querystring формату,
 * т.к. по дефолту axios отправляет JSON Payloads, а бэк по дефолту парсит FormData
 */

const { iso } = window.LANGUAGE_DATA.currentLanguage
const instance = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Pd-Translation-Language': iso,
  },
})

instance.interceptors.request.use(config => {
  dispatchCustomEventGlobally('axios:request', config)
  return config
})

export default instance
